import {ElementRef, Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {DataStateChangeEvent, GridComponent, GridDataResult, PageChangeEvent} from '@progress/kendo-angular-grid';
import {process} from '@progress/kendo-data-query';
import {FormBuilder, FormGroup} from '@angular/forms';
import {InventoryComponent} from '~/app/shared/inventory/inventory.component';
import {throwError} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class KendoGridHelperComponent {

    public _itemChangedGroup: any;
    public _formGroup: FormGroup;
    public _gridDataHelper: GridDataResult = null;
    public _gridDataHelperCategory: GridDataResult = null;
    // TODO make kendo helper generic, see if these can be imported here
    // TODO move to ui or keep in service?
    gridReference: ElementRef;
    public _gridDataHelperRad: any = null;
    public _gridDataHelperCatRad: any = null;
    public state: DataStateChangeEvent = {
        skip: 0,
        take: 0,
    };
    public stateCategory: DataStateChangeEvent = {
        skip: 0,
        take: 0,
    };
    public stateItems: DataStateChangeEvent = {
        skip: 0,
        take: 0,
    };
    selectedItem: any;
    public _gridDataHelperItems: GridDataResult = null;
    private renderer: Renderer2;
    private editedRowIndex: number;
    private docClickSubscription: () => void;

    constructor(private _formBuilder: FormBuilder, public rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    public createStateForGrid() {
        const stateEvent = {skip: 0, take: 0} as DataStateChangeEvent;
        return stateEvent;
    }

    // TODO make this reusable by everyone
    public process<T>(data: T[], state: any) {
        this._gridDataHelper = process(data, state);
    }

    public processItems<T>(data: T[], state: any) {
        this._gridDataHelperItems = process(data, state);

    }

    public processItemsAndReturn<T>(data: T[], state: any) {
        return process(data, state);
    }

    public processCategory<T>(data: T[], state: any) {
        this._gridDataHelperCategory = process(data, state);
    }

    pageChange($event: PageChangeEvent) {
        this.state.skip = $event.skip;
        this.state.take = $event.take;
    }

    pageChangeCategory($event: PageChangeEvent) {
        this.stateCategory.skip = $event.skip;
        this.stateCategory.take = $event.take;
    }

    dataStateChangeItems($event: DataStateChangeEvent) {

    }

    pageChangeAllItems($event: PageChangeEvent) {

    }

    public dataStateChange(state: DataStateChangeEvent) {
        this.state = state;

    }

    public applyDocumentBind(method: any) {
        this.docClickSubscription = this.renderer.listen('document', 'click', (event) => {
            const component = method as InventoryComponent;
            component.onDocumentClick(event);
        });
    }

    public dataStateChangeCategory(stateCategory: DataStateChangeEvent) {
        this.stateCategory = stateCategory;
    }

    public restartState() {
        this.state.skip = 0;
    }

    public restartStateCategory() {
        this.stateCategory.skip = 0;
    }

    public restartStateItems() {
        this.stateItems.skip = 0;
    }

    public getGridRefence() {
        return this.gridReference as unknown as GridComponent;
    }

    getFormGroup() {
        return this._formGroup;
    }

    setFormGroup(formGroup) {
        this._formGroup = formGroup;
    }

    public matches = (el, selector) => (el.matches || el.msMatchesSelector).call(el, selector);

    public createFormGroup(params) {
        return this._formBuilder.group(params);
    }

    closeEditor(): void {
        // @ts-ignore
        this.getGridRefence().closeRow(this.editedRowIndex);
        // this.isNew = false;
        this.editedRowIndex = undefined;
        this._formGroup = undefined;
    }

    public cancelHandler(): void {
        this.closeEditor();
    }

    public cellClickHandler({isEdited, dataItem, rowIndex}, formGroupTemplate: any) {
        let checkChangeGroup = false;
        if (isEdited || (this._formGroup && !this._formGroup.valid)) {

        }
        checkChangeGroup = this.saveCurrent(checkChangeGroup);
        this._formGroup = this.createFormGroup(formGroupTemplate);
        this.editedRowIndex = rowIndex;
        // @ts-ignore
        this.getGridRefence().editRow(rowIndex, this._formGroup);
        return checkChangeGroup;
    }

    saveCurrent(itemChanged: boolean): boolean {
        if (!this._formGroup) {
            return itemChanged;
        }
        try {

            itemChanged = true;
        } catch (error) {
            throwError(error);
        } finally {
            this.closeEditor();
            return itemChanged;
        }

    }

    public selectionChangeHandler($event: any) {
        this.selectedItem = $event.selectedRows[0].dataItem;
    }

    inventoryGridpageChange($event: PageChangeEvent) {

    }

    inventoryGriddataStateChange($event: DataStateChangeEvent) {

    }

}



